module.exports = __webpack_public_path__ + "static/007336-1d7d69ea31abe4d49befc2ef07b88e8c.jpg";